import consultations from '@/api/clinique/_consultations'

const absent = value => value === null || value === undefined || value === ''

export default {
    data() {
        return {
            tarif_manquant_visible: false, tarif_manquant_busy: false, tarif_manquant_prix: '',
            tarif_manquant_erreur: '', tarif_manquant_notice: '', tarif_manquant_contexte: null,
            tarif_a_recharger: false, tarif_composant_detruit: false
        }
    },
    computed: {
        peutRenseignerTarif() {
            return ['ROLE_CAISSIERE', 'ROLE_CAISSIERE_INTERMITENT', 'ROLE_ADMINISTRATEUR'].includes(this.activeRole.nom) &&
                !this.is_loading && !this.is_loading_tarif && !this.tarif_a_recharger &&
                !this.consultation_payment_recorded && !this.is_printable && !this.bon_is_printable &&
                Number(this.selected_type_consultation.consult_id) > 0 && Number(this.moment_selected) > 0 &&
                absent(this.tarif_consultation.prix_clinique)
        },
        libelleMomentTarif() {
            const moment = this.moment_consultations.find(item => Number(item.id) === Number(this.moment_selected))
            return moment ? moment.denomination : ''
        }
    },
    beforeDestroy() { this.tarif_composant_detruit = true },
    methods: {
        contexteTarifManquant() {
            return { patient_id: Number(this.chosen_patient.id), type_consultation_id: Number(this.selected_type_consultation.consult_id),
                moment_consultation_id: Number(this.moment_selected), can_set_pac: this.can_set_pac }
        },
        ouvrirTarifManquant() {
            if (!this.peutRenseignerTarif || this.tarif_manquant_busy) return
            this.tarif_manquant_contexte = this.contexteTarifManquant()
            this.tarif_manquant_prix = ''
            this.tarif_manquant_erreur = ''
            this.tarif_manquant_visible = true
        },
        fermerTarifManquant(event) {
            if (this.tarif_manquant_busy) event.preventDefault()
        },
        async rechargerTarifManquant() {
            if (this.is_loading_tarif || this.tarif_composant_detruit) return
            this.can_pay = false
            this.tarif_a_recharger = true
            try {
                const loaded = await this.getTarifConsultation(this.contexteTarifManquant())
                if (!this.tarif_composant_detruit) this.tarif_a_recharger = !loaded
            } catch (error) {
                this.can_pay = false
                this.is_loading_tarif = false
                this.error_message = 'Le tarif est enregistré, mais le bon n’a pas pu être recalculé. Réessayez le chargement.'
            }
        },
        async enregistrerTarifManquant() {
            if (this.tarif_manquant_busy || !this.tarif_manquant_visible || !this.peutRenseignerTarif) return
            this.tarif_manquant_erreur = ''
            const context = this.contexteTarifManquant()
            const original = this.tarif_manquant_contexte
            if (!original || ['patient_id', 'type_consultation_id', 'moment_consultation_id'].some(key => original[key] !== context[key])) {
                this.tarif_manquant_erreur = 'Le contexte du bon a changé. Fermez puis rouvrez ce formulaire.'
                return
            }
            const value = String(this.tarif_manquant_prix).trim()
            if (!/^\d+$/.test(value) || Number(value) < 1 || Number(value) > 2147483647) {
                this.tarif_manquant_erreur = 'Saisissez un prix entier supérieur à zéro (maximum 2 147 483 647).'
                return
            }
            this.tarif_manquant_busy = true
            this.can_pay = false
            let close = false
            try {
                await consultations.initialiserTarifManquant({ type_consultation_id: context.type_consultation_id,
                    moment_consultation_id: context.moment_consultation_id, prix: Number(value) })
                if (this.tarif_composant_detruit) return
                close = true
                this.tarif_manquant_notice = 'Tarif enregistré dans les paramètres pour les prochains bons de ce type et de ce moment.'
                await this.rechargerTarifManquant()
            } catch (error) {
                if (this.tarif_composant_detruit) return
                const response = error.response || {}, data = response.data || {}
                if (response.status === 409 && data.code === 'TARIFF_ALREADY_DEFINED') {
                    close = true
                    this.tarif_manquant_notice = 'Un tarif a déjà été renseigné. Le prix existant est conservé.'
                    await this.rechargerTarifManquant()
                } else {
                    const validation = data.errors && Object.values(data.errors)[0]
                    this.tarif_manquant_erreur = (validation && validation[0]) || data.message || 'Enregistrement non confirmé. Vérifiez la connexion puis réessayez ; aucun tarif existant ne sera écrasé.'
                }
            } finally {
                this.tarif_manquant_busy = false
                // Fermer après la fin du verrou, sinon @hide annulerait la fermeture.
                if (close && !this.tarif_composant_detruit) this.tarif_manquant_visible = false
            }
        }
    }
}
